/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EntityWithHistoryType } from './EntityWithHistoryType';
import {
    instanceOfEntityWithHistoryType,
    EntityWithHistoryTypeFromJSON,
    EntityWithHistoryTypeFromJSONTyped,
    EntityWithHistoryTypeToJSON,
} from './EntityWithHistoryType';

/**
 * @type HistoryDtoHiddenEntityType
 * 
 * @export
 */
export type HistoryDtoHiddenEntityType = EntityWithHistoryType;


export function HistoryDtoHiddenEntityTypeFromJSON(json: any): HistoryDtoHiddenEntityType {
    return HistoryDtoHiddenEntityTypeFromJSONTyped(json, false);
}

export function HistoryDtoHiddenEntityTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoryDtoHiddenEntityType {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...EntityWithHistoryTypeFromJSONTyped(json, true) };
    return  EntityWithHistoryTypeFromJSONTyped(json, true);
}

export function HistoryDtoHiddenEntityTypeToJSON(value?: HistoryDtoHiddenEntityType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfEntityWithHistoryType(value)) {
        return EntityWithHistoryTypeToJSON(value as EntityWithHistoryType);
    }

    return {};
}

/**
 * Check if a given object implements the HistoryDtoHiddenEntityType interface.
 */
export function instanceOfHistoryDtoHiddenEntityType(value: any): value is HistoryDtoHiddenEntityType {
    if (instanceOfEntityWithHistoryType(value)) return true;
    return false;
}

